const TOUR_STORAGE_PREFIX = "aq_qms_doc_workspace_tour_v1";

function getStorageKey(staffId, panelId) {
  const id = String(staffId || "").trim();
  const panel = String(panelId || "preview").trim();
  return id
    ? `${TOUR_STORAGE_PREFIX}_${panel}_${id}`
    : `${TOUR_STORAGE_PREFIX}_${panel}`;
}

export function hasCompletedQmsWorkspacePanelTour(staffId, panelId) {
  try {
    return localStorage.getItem(getStorageKey(staffId, panelId)) === "1";
  } catch {
    return false;
  }
}

export function markQmsWorkspacePanelTourCompleted(staffId, panelId) {
  try {
    localStorage.setItem(getStorageKey(staffId, panelId), "1");
  } catch {
    /* ignore quota errors */
  }
}
